import { motion } from "framer-motion";
import { Award, Clock, Download } from "lucide-react";
import { API_BASE } from "@/lib/api";

const categoryColors = {
  business: "bg-blue-50 text-blue-700 ring-blue-100",
  technology: "bg-purple-50 text-purple-700 ring-purple-100",
  leadership: "bg-orange-50 text-orange-700 ring-orange-100",
  entrepreneurship: "bg-teal-50 text-teal-700 ring-teal-100",
  culture: "bg-pink-50 text-pink-700 ring-pink-100",
  career: "bg-indigo-50 text-indigo-700 ring-indigo-100",
};

export default function ProgramCard({ program, index = 0 }) {
  const cat = categoryColors[program.category] || categoryColors.business;
  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: (index % 6) * 0.05 }}
      className="rounded-2xl bg-white border border-slate-100 shadow-sm hover:shadow-xl hover:shadow-blue-500/10 hover:-translate-y-1 transition-transform p-6 flex flex-col"
      data-testid={`program-card-${program.id}`}
    >
      <div className="flex items-center justify-between mb-3">
        <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full ring-1 ${cat}`}>
          {program.category}
        </span>
        {program.certificate && (
          <span className="inline-flex items-center gap-1 text-[11px] text-emerald-700 font-semibold">
            <Award className="w-3.5 h-3.5" /> Certificate
          </span>
        )}
      </div>

      <h3 className="font-display font-bold text-lg text-slate-900 mb-2 leading-snug">
        {program.title}
      </h3>
      <p className="text-sm text-slate-600 leading-relaxed line-clamp-3 mb-4 flex-1">
        {program.description}
      </p>

      <div className="flex items-center gap-2 text-xs text-slate-500 mb-4">
        <Clock className="w-3.5 h-3.5" />
        {program.duration_options?.join(" · ")}
      </div>

      <div className="flex items-center justify-between">
        <div className="flex flex-wrap gap-1">
          {(program.available_destinations || []).slice(0, 4).map((d) => (
            <span key={d} className="text-[10px] font-semibold uppercase text-slate-500 bg-slate-50 px-1.5 py-0.5 rounded">
              {d.slice(0, 3)}
            </span>
          ))}
        </div>
        <a
          href={`${API_BASE}/programs/${program.id}/brochure`}
          download
          data-testid={`program-brochure-${program.id}`}
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-blue-600 hover:text-blue-700"
        >
          <Download className="w-3.5 h-3.5" /> Brochure
        </a>
      </div>
    </motion.article>
  );
}
